/**
 * API service functions for public chat functionality
 * Handles retrieving shared chat data from the server
 */
import { services } from '../../../api';
import { ChatMessageItemType } from '../../../interfaces/api/qna';
import process from 'node:process';

/**
 * Retrieves chat history for a publicly shared chat
 * @param chatId - The unique identifier for the shared chat
 * @returns Promise containing an array of chat messages or an empty array if error
 */
export const getChats = async (chatId: string): Promise<ChatMessageItemType[]> => {
  try {
    const res = await services.share.getChatHistory(chatId);
    if (res.data) {
      return [...res.data.messages];
    }
    return [];
  } catch (ex) {
    if (process.env.REACT_APP_DEBUG === 'true') {
      console.error(ex);
    }
    return [];
  }
};
